import React from 'react';
import { CtaButton } from './ui/CtaButton';
const features = ['🌳 Árbol de Habilidades (póster doble)', '🛡️ Sistema de 5 Rangos y Escudos recortables', '🎁 20 Tarjetas de Poderes Especiales', '🎡 El Elegidor Veloz (rueda armable)', '📅 Tablero de Conquistas Mensual', '🗓️ Calendario de Días Temáticos anual', '🏆 La Semana Master de los 6 tomos', '🎓 Certificados de Graduación XL', '🚫📱 Plan del Día Cero Pantallas'];
export function TableroDetails() {
  return <section className="py-16 px-4 bg-zinc-950 border-t border-zinc-900" data-id="element-202">
      <div className="max-w-5xl mx-auto" data-id="element-203">
        <div className="text-center mb-10" data-id="element-204">
          <h2 className="text-3xl md:text-4xl font-bold mb-3 text-white" data-id="element-205">
            🕊️ ¿Qué agrega el Tablero de Control Familiar?
          </h2>
          <p className="text-lg text-zinc-400" data-id="element-206">
            Convierte el pack en un hábito de por vida.
          </p>
        </div>

        <div className="overflow-x-auto mb-10" data-id="element-207">
          <table className="w-full min-w-[600px] border-collapse" data-id="element-208">
            <thead data-id="element-209">
              <tr className="border-b border-zinc-800" data-id="element-210">
                <th className="text-left py-4 px-6 text-zinc-400 font-medium" data-id="element-211">
                  SITUACIÓN EN CASA
                </th>
                <th className="text-left py-4 px-6 text-red-400 font-medium bg-red-500/5" data-id="element-212">
                  ❌ Sin el Tablero
                </th>
                <th className="text-left py-4 px-6 text-cyan-400 font-medium bg-cyan-500/5" data-id="element-213">
                  ✅ Con Tablero
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-800/50" data-id="element-214">
              {[['Tu hijo pide hacer el pack', 'Lo convencés con esfuerzo', 'Lo pide solo por estrellas'], ['No sabés qué actividad dar hoy', 'Decidís con energía mental', 'La rueda decide sola'], ['Querés que el hábito dure', 'Dura mientras hay novedad', 'Sistema de 365 días'], ['El niño necesita incentivos', "Le decís 'muy bien' y ya", 'Gana poderes especiales']].map((row, i) => <tr key={i} className="hover:bg-zinc-900/30 transition-colors" data-id="element-215">
                  <td className="py-4 px-6 text-zinc-300" data-id="element-216">{row[0]}</td>
                  <td className="py-4 px-6 text-zinc-500 bg-red-500/5" data-id="element-217">
                    {row[1]}
                  </td>
                  <td className="py-4 px-6 text-white font-medium bg-cyan-500/5" data-id="element-218">
                    {row[2]}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-8 md:p-10" data-id="element-219">
          <h3 className="text-xl font-bold text-white mb-6 text-center" data-id="element-220">
            ✅ El Tablero incluye (+18 herramientas):
          </h3>
          <div className="grid md:grid-cols-3 gap-3 mb-8" data-id="element-221">
            {features.map((feature, i) => <div key={i} className="flex items-center gap-2 text-zinc-300 text-sm" data-id="element-222">
                <span className="text-base" data-id="element-223">{feature.split(' ')[0]}</span>
                <span data-id="element-224">{feature.substring(feature.indexOf(' ') + 1)}</span>
              </div>)}
          </div>
          <div className="text-center" data-id="element-225">
            <CtaButton label="QUIERO EL PACK + TABLERO" target="oferta-premium" data-id="element-226" />
          </div>
        </div>
      </div>
    </section>;
}